import { createApp } from 'vue';
import Antd from 'ant-design-vue';
import router from './router'
import store from './store'
import App from './App';
import 'ant-design-vue/dist/reset.css';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import 'dayjs/locale/zh-cn';
const app = createApp(App);
app.use(zhCN)
app.use(store);
app.use(router);
app.use(Antd);

app.mount('#app');